export const fieldNames = <const>{
    comment: 'comment',
};
